<template>
  <a-card>
    <div class="ant-descriptions-title">
      <span style="margin-top: 5px;">
        Leave Date / Ngày xin nghỉ phép
      </span>
    </div>
    <a-table
      :pagination="false"
      :columns="columns"
      :data-source="workLeaveDays"
      rowKey="id"
      bordered
      size="small"
    >
      <div slot="stt" slot-scope="text, record, index">
        {{ +index + 1 }}
      </div>
      <div slot="ToHour" slot-scope="text">
        {{ text | formatTime }}
      </div>
      <div slot="FromHour" slot-scope="text">
        {{ text | formatTime }}
      </div>
      <div slot="FromDate" slot-scope="text">
        {{ text | formatDate }}
      </div>
      <div slot="ToDate" slot-scope="text">
        {{ text | formatDate }}
      </div>
    </a-table>
  </a-card>
</template>
<script>
import query from "../../constant/query";

const columns = [
  {
    title: "Index",
    key: "stt",
    slots: { title: "stt" },
    scopedSlots: { customRender: "stt" },
    align: "center",
    width: 70,
  },
  {
    title: "Time Request",
    align: "center",
    key: "HinhThuc",
    children: [
      {
        title: "To",
        align: "center",
        key: "Tu",
        children: [
          {
            title: "Hour",
            align: "center",
            key: "FromHour",
            dataIndex: "startDate",
            scopedSlots: { customRender: "FromHour" },
          },
          {
            title: "Date",
            align: "center",
            key: "FromDate",
            dataIndex: "startDate",
            scopedSlots: { customRender: "FromDate" },
          },
        ],
      },
      {
        title: "To",
        align: "center",
        key: "To",
        children: [
          {
            title: "Hour",
            align: "center",
            key: "ToHour",
            dataIndex: "endDate",
            scopedSlots: { customRender: "ToHour" },
          },
          {
            title: "Date",
            align: "center",
            key: "ToDate",
            dataIndex: "endDate",
            scopedSlots: { customRender: "ToDate" },
          },
        ],
      },
    ],
  },

  {
    title: "Total",
    align: "center",
    key: "Total",
    children: [
      {
        title: "Days",
        dataIndex: "totalLeaveDays",
        align: "center",
        key: "totalLeaveDays",
      },
      {
        title: "Hours",
        dataIndex: "totalLeaveHours",
        align: "center",
        key: "totalLeaveHours",
      },
    ],
  },
];

export default {
  props: {
    workLeaveDays: {
      type: Array,
      required: true,
    },
    onUpdatedTotalLeaveDays: {
      type: Function,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      columns,
    };
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
